export const ZILLOW_DOM_STATUS_ID = '.ds-status-details'
export const ZILLOW_SUMMARY_SELECTOR = '.summary-container'
export const ZILLOW_SUMMARY_SELECTOR_2 = '.ds-chip-removable-content'
export const ZILLOW_OWNED_SELECTOR = '.hdp__sc-13xpdoz-0'
export const DENY_LISTING_STATUSES = ['rent', 'sold', 'closed', 'lot/land']
export const FETCH_ZILLOW_ELEMENT_TIMEOUT_MS = 15000
